import {put} from "redux-saga/effects";

import axios from "../../../../../api/axios"

import * as actions from "../../../../actions";
import * as api from "../../../../../api";
import {generateDynamicRoute} from "../../../../../utils/utils";

export function* enseignantMesCoursFetchCoursRessourcesSaga(action) {

    yield put(actions.enseignantMesCoursFetchCoursRessourcesStart());

    const coursId = action.payload.coursId;

    try {
        const response = yield axios.get(generateDynamicRoute(api.enseignantFetchCoursSections,[{toReplace:":coursId",value:coursId}]));//"https://run.mocky.io/v3/9720e6a4-ff4f-4ca3-8060-8cc89f35da15");
        console.log(response.data);
        yield put(actions.enseignantMesCoursFetchCoursRessourcesSuccess(response.data));
    } catch (error) {
        if(error.response) {
            yield put(actions.enseignantMesCoursFetchCoursRessourcesFail(error.response.data.error));
        }else {
            yield put(actions.enseignantMesCoursFetchCoursRessourcesFail("There's an error!"));
        }
    }

}